/**
 * Looks up the matching incidentReports entry (stored in the browser's mock
 * IndexedDB when running against the MSW mock API) and returns its status,
 * defaulting to 'O' (Open) when no report has been started yet.
 */
export async function getIncidentReportStatus(caseId: number, activityId: number): Promise<string> {
    const { default: CustomDB } = await import('../../../mock-utils/custom-db.mjs');
    const db = new CustomDB('incidentReports');
    const [incidentReport] = await db.findAll([
        { fieldName: 'caseId', values: caseId },
        { fieldName: 'activityId', values: activityId },
    ]);
    return incidentReport?.status ?? 'O';
}
